import type { MovementMuscleInfo } from '@az3fr/core';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { api } from '@/api/api-client';
import { movementMuscleSliceActions } from '@/entities/movement-muscle/model/movement-muscle.slice';
import { useAppDispatch } from '@/hooks/store.hook';

// @TODO: get this from the @az3fr/functions package
interface MovementMuscleResponse {
	data: MovementMuscleInfo[];
}

function useLoadAllMovementMuscleRawQuery() {
	const dispatch = useAppDispatch();

	// @todo: fix the typing
	const queryResult = useQuery<MovementMuscleResponse, Error>({
		queryKey: ['movement-muscle', 'all', 'raw'],
		queryFn: () => api.get<MovementMuscleResponse>('movement-muscle/all/raw'),
		staleTime: Number.POSITIVE_INFINITY,
		gcTime: Number.POSITIVE_INFINITY,
	});

	// Automatically cache fetched movements in the normalized store
	useEffect(() => {
		if (queryResult.data?.data) {
			dispatch(movementMuscleSliceActions.setAll(queryResult.data.data));
		}
	}, [queryResult.data, dispatch]);

	return queryResult;
}

export { useLoadAllMovementMuscleRawQuery };
